import { getCouponTitle } from '../../Utils'

export const generateResultPage = (data) => {
  if (!data) return ''
  const { result, mainPopup } = data
  const title = getCouponTitle(result.text?.content, mainPopup?.default_coupon?.code) || ''
  const titleStyle = result.text?.style || {}
  const text_1 = getCouponTitle(result.text_1?.content, mainPopup?.default_coupon?.code) || ''
  const text_1Style = result.text_1?.style || {}
  const buttonText = result.button?.content || ''
  const buttonStyle = result.button?.style || {}

  const html = `
    <div id="kariba_result_container_result_defaultcode"
      style="background: url(${result?.background?.url || ''}) no-repeat;
      position:fixed;
      background-size: cover;
      background-position: center;"
    >
        <div id="kariba_close_default_code" class="k-m-close-button"
        style="width:262px;text-align:right;margin-left:32px; cursor:pointer"
        >
          <i class="material-icons">&#xe5cd;</i>
        </div>
        <span style="font-family: ${titleStyle.fontFamily || 'Inter'}; 
          color: ${titleStyle.color || '#FA541C'};
          font-size: ${titleStyle.fontSize || 36}px;
          font-weight: ${titleStyle.fontStyle || 'bold'};
          text-align: ${titleStyle.textAlign || 'center'};
          width:262px;
          margin-bottom: 20px;
          ">${title}</span>

        <span style="font-family: ${text_1Style.fontFamily || 'Inter'}; 
          color: ${text_1Style.color || '#000000'};
          font-size: ${text_1Style.fontSize || 20}px;
          font-weight: ${text_1Style.fontStyle || 'bold'};
          text-align: ${text_1Style.textAlign || 'center'};
          width:262px;
          margin-bottom: 32px;
          ">${text_1}</span>

        <button
          id="kariba_continue_shopping"
          style="font-family: ${buttonStyle.fontFamily || 'Inter'}; 
          background-color: ${buttonStyle.backgroundColor || '#FA541C'};
          color: ${buttonStyle.color || '#FFF'};
          font-size: ${buttonStyle.fontSize || 12}px;
          font-weight: ${buttonStyle.fontStyle || 'nomal'};
          text-align: ${buttonStyle.textAlign || 'center'};
          height:40px;
          min-width: 262px;
          border-radius: 8px;
          border: none;
          outline: none;
          margin-bottom: 15px;
          cursor: pointer"
          >${buttonText}</button>
          <canvas id="kariba_effect_canvas"></canvas>
          <div id="effect_wrapper"></div>
    </div>`

  return html
}
